export function stickyElements() {
  // make elements sticky
  if ($(window).width() > 991) {

    $('.widget--sticky').stick_in_parent({
      parent: '.widget-sticky-wrapper',
      offset_top: 150,
      spacer: false
    });

  } else {
    $('.widget--sticky').trigger('sticky_kit:detach');
  }
}